module.exports = __webpack_public_path__ + "static/img/search_bt.2d3aaa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/search_bt.png
// module id = ZWIz
// module chunks = 1